;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();export type PropertyStaffRoleCategorySelector = Readonly<{
	kind: "role-category";
	category: "leasing-agent";
}>;

export const LEASING_AGENT_ROLE_CATEGORY = {
	category: "leasing-agent",
	kind: "role-category",
} as const satisfies PropertyStaffRoleCategorySelector;

export type PropertyStaffRoleFilter =
	| string
	| PropertyStaffRoleCategorySelector;

export function isLeasingAgentRole(userRole: string): boolean {
	const normalizedUserRole = userRole.trim().toLowerCase().replace(/\s+/g, " ");
	return normalizedUserRole.includes("leasing agent");
}

const DEFAULT_PROPERTY_MANAGER_ROLE_FILTERS = new Set(
	["Property Manager", "On-Site Manager"].map((roleLabel) =>
		roleLabel.trim().toLowerCase(),
	),
);

export function isServiceTechRole(userRole: string): boolean {
	const normalizedUserRole = userRole.trim().toLowerCase().replace(/\s+/g, " ");
	if (!normalizedUserRole) {
		return false;
	}
	return (
		normalizedUserRole === "service tech" ||
		normalizedUserRole.includes("maintenance")
	);
}

export function isPropertyManagerRole(
	userRole: string,
	propertyManagerRoleFilters: Iterable<string> = DEFAULT_PROPERTY_MANAGER_ROLE_FILTERS,
): boolean {
	const normalizedUserRole = userRole.trim().toLowerCase();
	if (!normalizedUserRole) {
		return false;
	}
	const normalizedRoleFilters = new Set(
		Array.from(propertyManagerRoleFilters).map((roleLabel) =>
			String(roleLabel).trim().toLowerCase(),
		),
	);
	return normalizedRoleFilters.has(normalizedUserRole);
}
